import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, Subscription, Observable } from 'rxjs';
import { WindowResizeService } from '../../global/window-resize.service';
import { map, take, withLatestFrom } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { User } from '../administration/user/user.models';
import { selectAuthUser } from '../auth/auth.selectors';
import { isNullOrUndefined } from 'util';

export interface HelpAndContactsTab {
  name: string;
  path: string;
}

export const HELP_AND_CONTACTS_TABS: HelpAndContactsTab[] = [
  {
    name: 'My Contacts',
    path: 'my-contacts'
  }/* ,
  {
    name: 'Help',
    path: 'help'
  } */,
  {
    name: 'My Connections',
    path: 'my-connections'
  },
  {
    name: 'Contact Us',
    path: 'contact-us'
  }
];

@Component({
  standalone: false,
  selector: 'dsp-help-and-contacts',
  templateUrl: 'help-and-contacts.container.html',
  styleUrls: ['help-and-contacts.container.scss']
})
export class HelpAndContactsContainerComponent implements OnInit, OnDestroy {
  public tabs$: Observable<HelpAndContactsTab[]>;
  public isMobile$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public selectedTabIndex$: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  private readonly subscription = new Subscription();
  public user$: Observable<User>;

  public constructor(
    private readonly store: Store<AppState>,
    private readonly router: Router,
    private readonly resize: WindowResizeService
  ) {
    this.user$ = this.store.pipe(select(selectAuthUser));
  }

  public ngOnInit(): void {
    this.subscription.add(this.subscribeAuthUser());
    this.subscription.add(this.subscribeIsMobile());
    this.subscription.add(this.subscribeTabChanges());
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private subscribeTabChanges(): Subscription {
    return this.router.events.pipe(
      withLatestFrom(this.tabs$)
    ).subscribe(([event, tabs]) => {
      if (event instanceof NavigationEnd) {
        let tab;
        if (event.urlAfterRedirects.indexOf('?my-contacts=') > -1) {
          tab = tabs.find((currentTab) => currentTab.path === 'contact-us') || '';
        } else {
          tab = tabs.find((currentTab) => event.urlAfterRedirects.indexOf(currentTab.path) > -1) || '';
        }
        const tabNames = [];
        tabs.forEach(record => {
          tabNames.push(record.name);
        });
        const index = tabNames.indexOf(tab.name);
        if (index > -1) {
          this.selectedTabIndex$.next(index);
        }
      }
    });
  }
  public onChangeTab(event: number): void {
    this.tabs$.pipe(take(1)).subscribe(tabs => {
      this.router.navigate([`/contacts/${tabs[event].path}`]);
    });
  }

  private subscribeAuthUser(): Subscription {
    return this.user$.subscribe(user => {
      if (!isNullOrUndefined(user)) {
        this.tabs$ = this.selectTabs(user.type);
      }
    });
  }

  private selectTabs(userType): Observable<HelpAndContactsTab[]> {
    if (userType === 'external') {
      return this.isMobile$.pipe(
        map(isMobile => isMobile ? HELP_AND_CONTACTS_TABS.filter(tab => tab.path !== 'help') : HELP_AND_CONTACTS_TABS)
      );
    } else {
      return this.isMobile$.pipe(
        map(isMobile =>
          // isMobile ? HELP_AND_CONTACTS_TABS.filter(tab => tab.path !== 'help' && tab.path !== 'my-contacts') :
          HELP_AND_CONTACTS_TABS.filter(tab => tab.path !== 'help' && tab.path !== 'my-contacts' && tab.path !== 'my-connections'))
      );
    }
  }

  private subscribeIsMobile(): Subscription {
    return this.resize.mobile$.subscribe(this.isMobile$);
  }
}
